import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmVatCorrectionsImportStore,
	TEmVatCorrectionsImportListRequest,
	TEmVatCorrectionsImportListResponsePayload,
	TLoadOrderVatCorrectionsForOrderRequestPayload,
	TEmVatCorrectionsImportListResponse,
} from './types';

const initialState: TEmVatCorrectionsImportStore = {
	list: null,
	listLoading: false,
	orderDetailRows: [],
	orderDetailLoading: false,
};

const emVatCorrectionsImportSlice = createSlice({
	name: 'emVatCorrectionsImport',
	initialState,
	reducers: {
		loadEmVatCorrectionsImportListRequest: (
			state,
			_action: PayloadAction<TEmVatCorrectionsImportListRequest>,
		) => {
			state.listLoading = true;
		},
		loadEmVatCorrectionsImportListSuccess: (
			state,
			action: PayloadAction<TEmVatCorrectionsImportListResponsePayload>,
		) => {
			state.list = action.payload;
			state.listLoading = false;
		},
		loadEmVatCorrectionsImportListFailure: (state) => {
			state.listLoading = false;
		},
		clearEmVatCorrectionsImportList: (state) => {
			state.list = null;
		},
		loadOrderVatCorrectionsForOrderRequest: (
			state,
			_action: PayloadAction<TLoadOrderVatCorrectionsForOrderRequestPayload>,
		) => {
			state.orderDetailLoading = true;
			state.orderDetailRows = [];
		},
		loadOrderVatCorrectionsForOrderSuccess: (
			state,
			action: PayloadAction<TEmVatCorrectionsImportListResponse>,
		) => {
			state.orderDetailRows = action.payload.rows ?? [];
			state.orderDetailLoading = false;
		},
		loadOrderVatCorrectionsForOrderFailure: (state) => {
			state.orderDetailLoading = false;
			state.orderDetailRows = [];
		},
		clearOrderVatCorrectionsForOrder: (state) => {
			state.orderDetailRows = [];
			state.orderDetailLoading = false;
		},
	},
});

export const {
	loadEmVatCorrectionsImportListRequest,
	loadEmVatCorrectionsImportListSuccess,
	loadEmVatCorrectionsImportListFailure,
	clearEmVatCorrectionsImportList,
	loadOrderVatCorrectionsForOrderRequest,
	loadOrderVatCorrectionsForOrderSuccess,
	loadOrderVatCorrectionsForOrderFailure,
	clearOrderVatCorrectionsForOrder,
} = emVatCorrectionsImportSlice.actions;

export default emVatCorrectionsImportSlice.reducer;
